import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

function CatalogCategory() {
    const roles = localStorage.getItem('role');
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
  return (
    <div className='klgcategory_main'>
        <div className='d-flex flex-column catalog_caregoryspans pe-3'>
            <h4>Categories</h4>
            <span className={currentPath === "/catalogs/global-services" ? "active_catalog mb-3" : "mb-3"} onClick={() =>{navigate("/catalogs/global-services")}}>Global Services</span>
            <span className={currentPath === "/catalogs/consulting-services" ? "active_catalog mb-3" : "mb-3"} onClick={() =>{navigate("/catalogs/consulting-services")}}>Consulting Services</span>
            {roles && roles === "job_seeker" && <>
            <span className={currentPath === "/catalogs/jobseeker-services" ? "active_catalog mb-3" : "mb-3"} onClick={() =>{navigate("/catalogs/jobseeker-services")}}>Jobseeker Services</span>
            </>}
        </div>
    </div>
  )
}

export default CatalogCategory
